import { PreviewModal } from '~/features/shared/components/preview-modal'
import * as m from '~/paraglide/messages'
import { EventPreview } from './event-preview'

interface EventPreviewModalProps {
  title: string
  description: string
  startTime: string
  location: {
    name?: string
    street: string
    city: string
    country: string
  }
  price: {
    kind: 'unknown' | 'free' | 'fixed' | 'range'
    priceFixed?: number
    priceRangeMin?: number
    priceRangeMax?: number
  }
  coverImageUrl?: string
  onFieldClick?: (fieldName: string) => void
}

export function EventPreviewModal({
  title,
  description,
  startTime,
  location,
  price,
  coverImageUrl,
  onFieldClick,
}: EventPreviewModalProps) {
  return (
    <PreviewModal
      title={m.eventPreview()}
      description={m.thisIsHowYourEventWillAppearToUsers()}
      onFieldClick={onFieldClick}
    >
      {(handleFieldClick) => (
        <EventPreview
          title={title}
          description={description}
          startTime={startTime}
          location={location}
          price={price}
          coverImageUrl={coverImageUrl}
          onFieldClick={handleFieldClick}
        />
      )}
    </PreviewModal>
  )
}
